import React from "react";
import MaturityTable from "./MaturityTable";

const AnalyticsMaturityLadder = ({ data }) => {
    if (!data) return null;

    return (
        <div className="keyDifference">
            <h4 className="title"><b>{data?.title}</b></h4>
            <p className="paragraph">{data?.subtitle}</p>
            <MaturityTable data={data} />
            {data?.paragraph?.map((para, parIndex) => <p key={parIndex} className="paragraph">{para?.para}</p>)}
            <div>
                <h5>{data?.BottomLine?.title}</h5>
                {data?.BottomLine?.paragraph?.map((bottom, botIndex) => <p key={botIndex} className="paragraph"><b>{bottom?.boldText}</b>{bottom?.text}</p>)}
            </div>
        </div>
    );
};

export default AnalyticsMaturityLadder;